import { ArchiveType } from "../../components-shared/enums/archive-type.js";

export function getModuleRelativePath(moduleUrl: string, relativePath: string) {
    const url = new URL(relativePath, moduleUrl);
    return url.pathname;
}

export function appendUrlParams(url: string, params: any): string {
    const result = new URL(url, document.baseURI);

    for (let name in params) {
        const value = params[name];
        result.searchParams.has(name) ? result.searchParams.set(name, value) : result.searchParams.append(name, value);
    }

    return `${result.pathname}?${result.searchParams}`;
}

export function getDownloadItemsAsZipUrl(itemIds: number[]): string {
    return appendUrlParams("/ViewFile.aspx", { ids: `[${itemIds.toString()}]` });
}

export class logicalUrl {
    public static getLogicalUrl(archiveType: ArchiveType, pageId: number, itemId: number, additionalParams?: any): string {
        switch (archiveType) {
            case ArchiveType.Page:
                if (!pageId) {
                    return "";
                }
                return appendUrlParams("/", { ...{ PageID: pageId }, ...additionalParams });
            case ArchiveType.Product:
            case ArchiveType.Document:
            case ArchiveType.Event:
                if (!itemId) {
                    return "";
                }
                return appendUrlParams("/Startup/Common/Main.aspx", { ...{ ItemID: itemId, ArchiveTypeID: ArchiveType[archiveType] }, ...additionalParams });
            case ArchiveType.Image:
                if (!itemId) {
                    return "";
                }
                return appendUrlParams("/ViewImage.aspx", { ...{ ItemID: itemId }, ...additionalParams });
            case ArchiveType.File:
                if (!itemId) {
                    return "";
                }
                return appendUrlParams("/ViewFile.aspx", { ...{ ItemID: itemId }, ...additionalParams });
            default:
                return "";
        }
    }

    public static getImageUrl(imageId: number, additionalParams?: any): string {
        return this.getLogicalUrl(ArchiveType.Image, 0, imageId, additionalParams);
    }

    public static getProductUrl(itemId: number): string {
        return this.getLogicalUrl(ArchiveType.Product, 0, itemId);
    }

    public static getDownloadItemsAsZipUrl(itemIds: number[]): string {
        return appendUrlParams("/ViewFile.aspx", { ids: `[${itemIds.toString()}]` });
    }
}
